import { useContext } from "react";
import PropTypes from "prop-types";

import { ConsoleIcon } from "../../client/assets/icons/common/ConsoleIcon";
import { SetupIcon } from "../../client/assets/icons/common/SetupIcon";
import { WandIcon } from "../../client/assets/icons/common/WandIcon";
import { twMerge } from "../../helpers/twMerge";
import { CompanyContext } from "../CompanyList/CompanyContext";

export const BaseBenefitPills = (props) => {
	const { company } = useContext(CompanyContext);
	const benefitPills = company.fields.modules?.benefitPills;
	if (!benefitPills || benefitPills.length === 0) return null;

	// eslint-disable-next-line react-js/prop-types
	const IconComponent = ({ icon, ...props }) => {
		switch (icon) {
			case "wand":
				return <WandIcon {...props} />;
			case "console":
				return <ConsoleIcon {...props} />;
			default:
				return <SetupIcon {...props} />;
		}
	};

	return (
		<ul
			{...props}
			className={twMerge(
				"tw:mt-2 tw:flex tw:flex-wrap tw:gap-2 tw:lg:mt-4",
				props.className,
			)}
		>
			{benefitPills.map((benefit, i) => (
				<li
					key={i}
					className="tw:flex tw:w-max tw:items-center tw:justify-center tw:gap-2 tw:rounded-full tw:bg-[#232529] tw:py-1 tw:pr-2 tw:pl-1 tw:lg:p-2"
				>
					<div className="tw:flex tw:size-5 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:bg-white tw:lg:size-6">
						<IconComponent
							icon={benefit.icon}
							className="tw:text-sm tw:text-[#232529] tw:lg:text-base"
						/>
					</div>
					{benefit?.value && (
						<span className="tw:text-sm tw:font-medium tw:text-white">
							{benefit.value}
						</span>
					)}
				</li>
			))}
		</ul>
	);
};

BaseBenefitPills.propTypes = {
	className: PropTypes.string,
};
